import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const items =  new Vuex.Store({
  state: {
    allUsersData:[],
//    userData:[],
    userData:{
        userId:0,
        userName:'Jhon',
        userLastName:'Snow',
        userNick:'Know Nothig',
        roles:[
          {
            user:true,
            admin:false
          }
        ],
        cars:[
          {
            carId: 0,
            carImage: require('../assets/img/audi.jpg'),
            carManufacture: 'Audi',
            carModel: 'A6',
            carYear:2003,
            carFuel: 'gasoline',
            carDrive: 'FWD',
            carEngineCapacity: 2400,
            carBoosted:false,
          },
          {
            carId: 1,
            carImage: require('../assets/img/audi.jpg'),
            carManufacture: 'Audi',
            carModel: 'A6',
            carYear:2003,
            carFuel: 'gasoline',
            carDrive: 'FWD',
            carEngineCapacity: 2400,
            carBoosted:false,
          },
          {
            carId: 2,
            carImage: require('../assets/img/audi.jpg'),
            carManufacture: 'Audi',
            carModel: 'A6',
            carYear:2003,
            carFuel: 'gasoline',
            carDrive: 'FWD',
            carEngineCapacity: 2400,
            carBoosted:false,
          }
        ],
        tickets:[
          {
            leagueId:0,
            leagueName:'roxa',
            leagueAdmin:'alfons',
            seasonPass: true,
            seasonNumber:1,
            seasonGrandPrix:true,
            races:[
              {
                raceId:0,
                ticetBought: true,
                raceNumber: 1,
                raceName:'Pszczółki',
                raceLocalization: 'Tor Pszczółki',
                raceDate:'01.03.2020',
                paidPrice:500
              },
              {
                raceId:1,
                ticketBought:true,
                raceNumber: 1,
                raceName:'Pszczółki',
                raceLocalization: 'Tor Pszczółki',
                raceDate:'23.03.2020',
                paidPrice:500
              }
            ]
          },
          {
            leagueId:1,
            leagueName:'time-attack',
            leagueAdmin:'rcp',
            seasonPass: true,
            seasonNumber:1,
            seasonGrandPrix:false,
            races:[
              {
                raceId:0,
                ticetBought: true,
                raceNumber: 23,
                raceName:'Kowalew',
                raceLocalization: 'Tor Kowalew',
                raceDate:'23.04.2020',
                paidPrice:300
              },
              {
                raceId:1,
                ticketBought:true,
                raceNumber: 23,
                raceName:'Pszczyna',
                raceLocalization: 'Tor Pszczyna',
                raceDate:'23.05.2020',
                paidPrice:300
              }
            ]
          }
        ],
        payments:[],
        statistics:[]
      },
    leagues:[
        {   
          leagueId:0,
          leagueDescription:false,
          leagueName:'time-attack',
          leagueBanner:require(`@/assets/img/rcp.png`),
          leagueAdmin:'rcp',
          racesAmount:'6',
          localizationsAmount:'4',
          seasonPass:true,
          seasonGrandPrix:false,
          avaibleSpots:true,
          description:'Organizator firma RCP z pomoża w tym sezonie przyotował super nagrody. Zostały one ufundowane przez sponsorów #sponsor1 #sponsor2. Specjalnymi gośćmi w tym sezonie będą #firmaX',
          races:[
            {
              raceId:0,
              raceName:'Pszczółki',
              raceLocalization: 'Tor Pszczółki',
              raceDate:'01.03.2020',
              amountOfSlots: 40,
              availableDriverSlots: 1,
              loopLenght:2.5,
              timePerStage: 15,
              preTicketPrice: 300,
              ticketPrice:350,
              availableSlots:false,
              showDescription:true,
              raceDescription:"Kazakhstan is the greatest country in the world. All other countries are run by little girls. Kazakhstan is number-one exporter of potassium. Other Central Asian countries have inferior potassium. Kazakhstan is the greatest country in the world. All other countries is the home of the gays...",
              lowerPrice:false,
              beforeRaceDate:true,
              location:[54.178377, 18.7123465],
              drivers:[
                {id:0,nick:"Tomaszol",number:1},
                {id:10,nick:"Dariuszo",number:2},
                {id:13,nick:"Roberto",number:3},
                {id:12,nick:"Michalow",number:31},
                {id:41,nick:"Adamosz",number:11}
              ],
              results:[
                {place:1,id:0,nick:"Tomaszol", number:1},
                {place:2,id:10,nick:"Dariuszo", number:2},
                {place:3,id:13,nick:"Roberto", number:3},
                {place:4,id:12,nick:"Michalow", number:31},
                {place:5,id:41,nick:"Adamosz", number:11},
              ]
            },
            {
              raceId:1,
              raceName:'Pszczółki',
              raceLocalization: 'Tor Pszczółki',
              raceDate:'01.03.2020',
              amountOfSlots: 40,
              availableDriverSlots: 1,
              loopLenght:2.5,
              timePerStage: 15,
              preTicketPrice: 300,
              ticketPrice:350,
              availableSlots:true,
              showDescription:false,
              raceDescription:"Um, at the start, she was a cook good, her vazhïn work well, and she strong on plow. But after three years, when she was 15, then she become weak. Her voice become a deep. Borat, Borat. She a receive hair on her chest and her vazhïn hang like sleeve of wizard.",
              lowerPrice:false,
              beforeRaceDate:true,
              location:[54.178377, 18.7123465],
              drivers:[
                {id:0,nick:"Tomaszol",number:1},
                {id:10,nick:"Dariuszo",number:2},
                {id:13,nick:"Roberto",number:3},
                {id:12,nick:"Michalow",number:31},
                {id:41,nick:"Adamosz",number:11}
              ],
              results:[
                {place:1,id:0,nick:"Tomaszol", number:1},
                {place:2,id:10,nick:"Dariuszo", number:2},
                {place:3,id:13,nick:"Roberto", number:3},
                {place:4,id:12,nick:"Michalow", number:31},
                {place:5,id:41,nick:"Adamosz", number:11},
              ]
            }
          ]
      },
      {   
        leagueId:1,
        leagueDescription:false,
        leagueName:'time-attack',
        leagueBanner:require(`@/assets/img/rcp.png`),
        leagueAdmin:'rcp',
        racesAmount:'6',
        localizationsAmount:'4',
        seasonPass:true,
        seasonGrandPrix:false,
        avaibleSpots:false,
        description:"Organizator firma RCP z pomoża w tym sezonie przyotował super nagrody. Zostały one ufundowane przez sponsorów #sponsor1 #sponsor2. Specjalnymi gośćmi w tym sezonie będą #firmaX",
        races:[
          {
              raceId:0,
              raceName:'Pszczółki',
              raceLocalization: 'Tor Pszczółki',
              raceDate:'01.03.2020',
              amountOfSlots: 40,
              availableDriverSlots: 1,
              loopLenght:2.5,
              timePerStage: 15,
              preTicketPrice: 300,
              ticketPrice:350,
              availableSlots:true,
              showDescription:false,
              raceDescription:"What's up with it, vanilla face? Me and my homie Azamat just parked our slab outside. We're looking for somewhere to post up our black asses for the night. So, uh, bang bang, skeet skeet, nigga. Just a couple of pimps, no hoes.",
              lowerPrice:false,
              beforeRaceDate:true,
              location:[52.4004458, 16.7615836],
              drivers:[
                {id:0,nick:"Tomaszol",number:1},
                {id:10,nick:"Dariuszo",number:2},
                {id:13,nick:"Roberto",number:3},
                {id:12,nick:"Michalow",number:31},
                {id:41,nick:"Adamosz",number:11}
              ],
              results:[]
          },
          {
            raceId:1,
            raceName:'Koszalin',
            raceLocalization: '"Moto Park" Koszalin - Ośrodek Sportów Motorowych',
            raceDate:'20.03.2020',
            amountOfSlots: 40,
            availableDriverSlots: 1,
            loopLenght:2.5,
            timePerStage: 15,
            preTicketPrice: 300,
            ticketPrice:350,
            availableSlots:true,
            showDescription:false,
            raceDescription:"This C.J. was like no Kazakh woman I have ever seen. She had golden hairs, teeth as white as pearls, and the asshole of a seven-year-old. For the first time in my lifes, I was in love.",
            lowerPrice:false,
            beforeRaceDate:true,
            location:[54.1785541, 16.1899422],
            drivers:[
              {id:0,nick:"Tomaszol",number:1},
              {id:10,nick:"Dariuszo",number:2},
              {id:13,nick:"Roberto",number:3},
              {id:12,nick:"Michalow",number:31},
              {id:41,nick:"Adamosz",number:11}
            ],
            results:[
              {place:1,id:0,nick:"Tomaszol", number:1},
              {place:2,id:10,nick:"Dariuszo", number:2},
              {place:3,id:13,nick:"Roberto", number:3},
              {place:4,id:12,nick:"Michalow", number:31},
              {place:5,id:41,nick:"Adamosz", number:11},
            ]
        }
        ]
    },
    {   
      leagueId:2,
      leagueDescription:false,
      leagueName:'time-attack',
      leagueBanner:require(`@/assets/img/rcp.png`),
      leagueAdmin:'rcp',
      racesAmount:'6',
      localizationsAmount:'4',
      seasonPass:true,
      seasonGrandPrix:false,
      avaibleSpots:true,
      description:"Organizator firma RCP z pomoża w tym sezonie przyotował super nagrody. Zostały one ufundowane przez sponsorów #sponsor1 #sponsor2. Specjalnymi gośćmi w tym sezonie będą #firmaX",
      races:[
        {
            raceId:0,
            raceName:'Pszczółki',
            raceLocalization: 'Tor Pszczółki',
            raceDate:'01.03.2020',
            amountOfSlots: 40,
            availableDriverSlots: 1,
            loopLenght:2.5,
            timePerStage: 15,
            preTicketPrice: 300,
            ticketPrice:350,
            availableSlots:true,
            showDescription:false,
            raceDescription:"What's up with it, vanilla face? Me and my homie Azamat just parked our slab outside. We're looking for somewhere to post up our black asses for the night. So, uh, bang bang, skeet skeet, nigga. Just a couple of pimps, no hoes.",
            lowerPrice:false,
            beforeRaceDate:true,
            location:[52.4004458, 16.7615836],
            drivers:[
              {id:0,nick:"Tomaszol",number:1},
              {id:10,nick:"Dariuszo",number:2},
              {id:13,nick:"Roberto",number:3},
              {id:12,nick:"Michalow",number:31},
              {id:41,nick:"Adamosz",number:11}
            ],
            results:[
              {place:1,id:0,nick:"Tomaszol", number:1},
              {place:2,id:10,nick:"Dariuszo", number:2},
              {place:3,id:13,nick:"Roberto", number:3},
              {place:4,id:12,nick:"Michalow", number:31},
              {place:5,id:41,nick:"Adamosz", number:11},
            ]
        },
        {
          raceId:1,
          raceName:'Koszalin',
          raceLocalization: '"Moto Park" Koszalin - Ośrodek Sportów Motorowych',
          raceDate:'20.03.2020',
          amountOfSlots: 40,
          availableDriverSlots: 1,
          loopLenght:2.5,
          timePerStage: 15,
          preTicketPrice: 300,
          ticketPrice:350,
          availableSlots:true,
          showDescription:false,
          raceDescription:"This C.J. was like no Kazakh woman I have ever seen. She had golden hairs, teeth as white as pearls, and the asshole of a seven-year-old. For the first time in my lifes, I was in love.",
          lowerPrice:false,
          beforeRaceDate:true,
          location:[54.1785541, 16.1899422],
          drivers:[
            {id:0,nick:"Tomaszol",number:1},
            {id:10,nick:"Dariuszo",number:2},
            {id:13,nick:"Roberto",number:3},
            {id:12,nick:"Michalow",number:31},
            {id:41,nick:"Adamosz",number:11}
          ],
          results:[]
      }
      ]
  },
  {   
    leagueId:3,
    leagueDescription:false,
    leagueName:'time-attack',
    leagueBanner:require(`@/assets/img/rcp.png`),
    leagueAdmin:'rcp',
    racesAmount:'6',
    localizationsAmount:'4',
    seasonPass:true,
    seasonGrandPrix:false,
    avaibleSpots:false,
    description:"Organizator firma RCP z pomoża w tym sezonie przyotował super nagrody. Zostały one ufundowane przez sponsorów #sponsor1 #sponsor2. Specjalnymi gośćmi w tym sezonie będą #firmaX",
    races:[
      {
          raceId:0,
          raceName:'Pszczółki',
          raceLocalization: 'Tor Pszczółki',
          raceDate:'01.03.2020',
          amountOfSlots: 40,
          availableDriverSlots: 1,
          loopLenght:2.5,
          timePerStage: 15,
          preTicketPrice: 300,
          ticketPrice:350,
          availableSlots:true,
          showDescription:false,
          raceDescription:"What's up with it, vanilla face? Me and my homie Azamat just parked our slab outside. We're looking for somewhere to post up our black asses for the night. So, uh, bang bang, skeet skeet, nigga. Just a couple of pimps, no hoes.",
          lowerPrice:false,
          beforeRaceDate:true,
          location:[52.4004458, 16.7615836],
          drivers:[
            {id:0,nick:"Tomaszol",number:1},
            {id:10,nick:"Dariuszo",number:2},
            {id:13,nick:"Roberto",number:3},
            {id:12,nick:"Michalow",number:31},
            {id:41,nick:"Adamosz",number:11}
          ],
          results:[
            {place:1,id:0,nick:"Tomaszol", number:1},
            {place:2,id:10,nick:"Dariuszo", number:2},
            {place:3,id:13,nick:"Roberto", number:3},
            {place:4,id:12,nick:"Michalow", number:31},
            {place:5,id:41,nick:"Adamosz", number:11},
          ]
      },
      {
        raceId:1,
        raceName:'Koszalin',
        raceLocalization: '"Moto Park" Koszalin - Ośrodek Sportów Motorowych',
        raceDate:'20.03.2020',
        amountOfSlots: 40,
        availableDriverSlots: 1,
        loopLenght:2.5,
        timePerStage: 15,
        preTicketPrice: 300,
        ticketPrice:350,
        availableSlots:true,
        showDescription:false,
        raceDescription:"This C.J. was like no Kazakh woman I have ever seen. She had golden hairs, teeth as white as pearls, and the asshole of a seven-year-old. For the first time in my lifes, I was in love.",
        lowerPrice:false,
        beforeRaceDate:true,
        location:[54.1785541, 16.1899422],
        drivers:[
          {id:0,nick:"Tomaszol",number:1},
          {id:10,nick:"Dariuszo",number:2},
          {id:13,nick:"Roberto",number:3},
          {id:12,nick:"Michalow",number:31},
          {id:41,nick:"Adamosz",number:11}
        ],
        results:[
          {place:1,id:0,nick:"Tomaszol", number:1},
          {place:2,id:10,nick:"Dariuszo", number:2},
          {place:3,id:13,nick:"Roberto", number:3},
          {place:4,id:12,nick:"Michalow", number:31},
          {place:5,id:41,nick:"Adamosz", number:11},
        ]
    }
    ]
}
    ],
 //   leagues:[],
    token:null,
    name:null,
    stan:null,
    user:null,
    seasonCreator:{
      leagues:[
        {
          id:1,
          leagueName:'time-attack',
          leagueAvatar:'',
          amountsOfEvents:10,
        }
      ]
    }
  },
  mutations: {
    GET_ALL_USERS_DATA(state,data){
      state.allUsersData = data
    },
    GET_USER_DATA(state,data){
      state.userData = data;
    },
    SET_USER_DATA(state,userData){
      state.user = userData
      state.token = userData.token
      state.stan = 'zalogowany'
      localStorage.setItem('login',userData.login)
      localStorage.setItem('password',userData.password)
      localStorage.setItem('token',userData.token)
      localStorage.setItem('stan','zalogowany')
      axios.defaults.headers.common['Authorization']=`Bearer ${userData.token}`
    },
    SET_LEAGUES_DATA(state,data){
      state.leagues = data;
    },
    CLEAR_USER_DATA(){
      localStorage.removeItem('login')
      localStorage.removeItem('password')
      localStorage.removeItem('token')
      localStorage.removeItem('stan')
      location.reload()
    },
    setLeague(state, league) {
      state.leagues = league
    },
    setToken(state,token){
      state.token = token
    },
    clearData(state){
      state.leagues=[];
      state.token= null;
      state.stan= null;
      state.name=null;
    },
    /// Admin Panel Mutations
    ADD_NEW_LEAGUE(state,leagueData){
      state.seasonCreator.leagues.push({
        id:state.seasonCreator.leagues.length+1,
        leagueName: leagueData.leagueName,
        leagueAvatar: leagueData.leagueAvatar,
        amountsOfEvents:0
      })
    } 
  },
  actions: {
    fetchUserData({commit},userId){
      // const proxy = "https://cors-anywhere.herokuapp.com/"
      const test = axios.create({
        withCredentials: true
      })
      return test
        .get(`https://raceapp.didevelopment.pl/api/user/get-by-id/${userId}`)
        .then(({data})=>{
          commit('GET_USER_DATA',data)
        })
      // return axios
      //   .get(`https://raceapp.didevelopment.pl/api/user/get-by-id/${userId}`)
      //   .then(({data})=>{
      //     commit('GET_USER_DATA',data)
      //   })
    },
    fetchAllUsersData({commit}){
      //const proxy = "https://cors-anywhere.herokuapp.com/"


      const test = axios.create({
        withCredentials: true
      })
      return test
      .get(`https://raceapp.didevelopment.pl/api/user/get-all`)
      .then(({data})=>{
        commit('GET_ALL_USERS_DATA',data)
      })

      // return axios
      //   .get(`https://raceapp.didevelopment.pl/api/user/get-all`)
      //   .then(({data})=>{
      //     commit('GET_ALL_USERS_DATA',data)
      //   })
    },
    fetchLeaguesData({commit}){
      return axios
        .get(`https://raceapp.didevelopment.pl/api/league/get-list`)
        .then(response =>{
          commit('SET_LEAGUES_DATA',response.data)
        })
    },
    login({commit},credentials){
      var aes256 = require('aes256');
      var key = 'd41d8cd98f00b204e9800998ecf8427e';
      let credentialsToSend = {
        login: aes256.decrypt(key,credentials.login),
        password: aes256.decrypt(key,credentials.password)
      }
      //const proxy = "https://cors-anywhere.herokuapp.com/"
      return axios
        .post(`https://raceapp.didevelopment.pl/api/user/authenticate`,credentialsToSend)
        .then(({data})=>{
          credentialsToSend.login = aes256.encrypt(key,credentials.login),
          credentialsToSend.password = aes256.encrypt(key,credentials.password)
          credentialsToSend.token=data.token
          commit('SET_USER_DATA',credentialsToSend)
        })
    },
    logout({commit}){
      commit('CLEAR_USER_DATA')
    },
    logoutClearData(){
      return this.commit('clearData')
    },
    fetchLeagueData({commit}){
      return axios
        .fetchLeague()
        .then(league =>{ 
          commit('setLeague',league)
        })
    },
    postAuth({commit}){
      return axios
        .postAuth()
        .then(token => {
          commit('setToken',token.data.token)
        })
        .catch(() => {commit('setToken','error')})
    },
    /// Admin Panel Actions
    addNewLeague({commit},leagueData){
      return commit('ADD_NEW_LEAGUE',leagueData);
    },

  },
  modules: {
  },
  getters:{
    logerdIn(state){
      return !!state.user
    },
    getLeagues: (state) => {
      return state.leagues.filter(league => league.leagueName)
    },
    getLeague: (state) => (id) =>{
      return state.leagues.find(league => league.leagueId === id )
    },
    getRace: (state, getters) => (league_id, race_id) => {
      return getters.getLeague(league_id).races.find(race => race.raceId === race_id)
    },
    getLeaguesAdmin:(state) => {
      return state.seasonCreator.leagues;
    }
  }
})
export default items;
